import { motion } from "framer-motion";
import { IMAGES } from "@/lib/api";

export default function Hero() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden grain">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Rose spiral sacred geometry" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#f7efe2]/70 via-[#f7efe2]/30 to-[#f7efe2]" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center pt-24">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="font-accent text-[13px] md:text-sm tracking-widest-2 uppercase text-[#9c5560] mb-6"
        >
          You are entering a living field of remembrance
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.15 }}
          className="font-display text-5xl md:text-7xl lg:text-[5.4rem] leading-[1.05] text-[#3a2630]"
        >
          Awaken your inner self
          <br />
          <span className="italic text-[#b76e79]">& original resonance</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.35 }}
          className="text-base md:text-lg text-[#3a2630]/75 mt-7 max-w-xl mx-auto leading-relaxed"
        >
          Guided support through sound, frequency, and presence — helping you remember
          what you have always known.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.55 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button
            data-testid="hero-contact-btn"
            onClick={() => scrollTo("#contact")}
            className="font-accent tracking-wide px-8 py-3.5 rounded-full bg-[#b76e79] text-[#f7efe2] hover:bg-[#9c5560] transition-colors shadow-[0_10px_30px_rgba(156,85,96,0.25)]"
          >
            Get in Touch
          </button>
          <button
            data-testid="hero-music-btn"
            onClick={() => scrollTo("#music")}
            className="font-accent tracking-wide px-8 py-3.5 rounded-full border border-[#b76e79] text-[#9c5560] hover:bg-[#b76e79] hover:text-[#f7efe2] transition-colors"
          >
            Hear the Music
          </button>
        </motion.div>
      </div>
    </section>
  );
}
